import React from "react";

const baseProps = {
  width: "48",
  height: "48",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const EmpathyIcon = () => (
  <svg {...baseProps}>
    <path d="M12 21s-6-4.35-9-8.5C1 9 3 5 7 5c2 0 3.5 1.2 5 3 1.5-1.8 3-3 5-3 4 0 6 4 4 7.5-3 4.15-9 8.5-9 8.5z" />
  </svg>
);

export const RespectIcon = () => (
  <svg {...baseProps}>
    {/* Head */}
    <circle cx="12" cy="7" r="3" />
    {/* Body */}
    <path d="M5 21v-2a7 7 0 0 1 14 0v2" />
  </svg>
);

export const SupportIcon = () => (
  <svg {...baseProps}>
    <path
      d="M22 16.92v3a2 2 0 0 1-2.18 2
             19.79 19.79 0 0 1-8.63-3.07
             19.5 19.5 0 0 1-6-6
             19.79 19.79 0 0 1-3.07-8.67
             A2 2 0 0 1 4.11 2h3
             a2 2 0 0 1 2 1.72
             12.84 12.84 0 0 0 .7 2.81
             2 2 0 0 1-.45 2.11L8.09 9.91
             a16 16 0 0 0 6 6
             l1.27-1.27
             a2 2 0 0 1 2.11-.45
             12.84 12.84 0 0 0 2.81.7
             A2 2 0 0 1 22 16.92z"
    />
  </svg>
);

export const GrowthIcon = () => (
  <svg {...baseProps}>
    {/* Axes */}
    <path d="M4 20V4" />
    <path d="M4 20H20" />
    {/* Rising graph line */}
    <path d="M6 15l4-4 4 3 4-6" />
  </svg>
);

export const OnlineTrainingIcon = () => (
  <svg {...baseProps}>
    <rect x="3" y="4" width="18" height="12" rx="2" />
    <path d="M8 20h8" />
    <path d="M12 16v4" />
  </svg>
);

export const PhysicalTrainingIcon = () => (
  <svg {...baseProps}>
    <circle cx="8" cy="8" r="3" />
    <circle cx="16" cy="8" r="3" />
    <path d="M2 20v-2a4 4 0 0 1 4-4h4" />
    <path d="M22 20v-2a4 4 0 0 0-4-4h-4" />
  </svg>
);

export const HybridTrainingIcon = () => (
  <svg {...baseProps}>
    <path d="M3 12a9 9 0 0 1 15-6" />
    <path d="M21 12a9 9 0 0 1-15 6" />
    <path d="M18 3v4h-4" />
    <path d="M6 21v-4h4" />
  </svg>
);
